import React from 'react'
import { Typography, Chip, CircularProgress } from '@material-ui/core'
import { QUESTION_STATUS_LABELS, QUESTION_STATUS_COLORS, PRIORITY_COLORS, PRIORITY_LABELS } from '../../constants/contextEnums'

const truncate = (s, n) => (!s ? '' : s.length > n ? s.slice(0, n) + '...' : s)

const QuestionsTab = ({ items, loading, onOpenThread }) => {
  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', padding: 20 }}><CircularProgress size={20} /></div>
  if (items.length === 0) {
    return <Typography variant="body2" color="textSecondary" style={{ padding: 24, textAlign: 'center' }}>No open questions. Raise one when something is unknown.</Typography>
  }
  return items.map((q) => (
    <div
      key={q._id}
      style={{ padding: '10px 0', borderBottom: '1px solid var(--line-1, #eee)', cursor: 'pointer' }}
      onClick={() => onOpenThread(q)}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
        <Chip
          label={QUESTION_STATUS_LABELS[q.status] || q.status}
          size="small"
          style={{ height: 20, fontSize: 11, backgroundColor: QUESTION_STATUS_COLORS[q.status] || '#9e9e9e', color: '#fff' }}
        />
        {q.priority && q.priority !== 'normal' && (
          <Chip label={PRIORITY_LABELS[q.priority] || q.priority} size="small" style={{ height: 18, fontSize: 10, backgroundColor: PRIORITY_COLORS[q.priority], color: '#fff' }} />
        )}
        {q.parent_label && <Chip label={q.parent_label} size="small" variant="outlined" style={{ height: 18, fontSize: 10 }} />}
      </div>
      <div style={{ fontSize: 13, fontWeight: 500 }}>{q.title}</div>
      {q.body && <div style={{ fontSize: 12, color: 'var(--ink-3)', marginTop: 2 }}>{truncate(q.body, 100)}</div>}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 4, fontSize: 11, color: 'var(--ink-3)' }}>
        <span>{'💬'} {(q.replies || []).length}</span>
        {q.resulting_decision_id && <span style={{ color: 'var(--ok, #2e7d32)' }}>{'→'} Decision</span>}
        {q.escalated_blocker_id && <span style={{ color: 'var(--risk, #d32f2f)' }}>{'⚠'} Blocker</span>}
      </div>
    </div>
  ))
}

export default QuestionsTab
